import { getBifrost } from "@cars24/omniauth/bifrost";

// Singleton promise to prevent multiple simultaneous refresh attempts
let refreshTokenPromise = null;

/**
 * Get tokens from localStorage
 */
export const getTokens = () => ({
  accessToken: localStorage.getItem("accessToken"),
  refreshToken: localStorage.getItem("refreshToken"),
  sessionId: localStorage.getItem("sessionId")
});

/**
 * Update tokens in localStorage
 */
export const updateTokens = (accessToken, refreshToken, sessionId) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
  if (sessionId) {
    localStorage.setItem("sessionId", sessionId);
  }
};

/**
 * Clear all authentication data and redirect to login
 */
export const clearAuthAndRedirect = () => {
  localStorage.clear();
  sessionStorage.clear();
  window.location = "/";
};

/**
 * Attempt to refresh the access token using Bifrost
 * Returns true if successful, false otherwise
 */
const attemptTokenRefresh = async () => {
  try {
    const { refreshToken, sessionId } = getTokens();

    // If no refresh token or session ID, cannot refresh
    if (!refreshToken || !sessionId) {
      console.warn("Missing refresh token or session ID");
      return false;
    }

    const bifrost = getBifrost();
    const response = await bifrost.refreshToken({
      refreshToken,
      sessionId
    });

    if (response?.data?.access_token) {
      // Update stored tokens
      updateTokens(response.data.access_token, response.data.refresh_token, response.data.session_id || sessionId);
      return true;
    }

    return false;
  } catch (error) {
    console.error("Token refresh failed:", error);
    return false;
  } finally {
    // Always clear the promise to allow future refresh attempts
    refreshTokenPromise = null;
  }
};

/**
 * Refresh token with promise lock to prevent multiple simultaneous attempts
 * All concurrent calls will wait for the same promise
 */
export const refreshTokenWithLock = async () => {
  // If a refresh is already in progress, return that promise
  if (refreshTokenPromise) {
    return refreshTokenPromise;
  }

  // Create new refresh promise
  refreshTokenPromise = attemptTokenRefresh();
  return refreshTokenPromise;
};
